import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { UIText3, IconWarning16, IconTrust16 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { LabelsLayout, ReliableLabel } from '../../components/Labels';
import { getIsReliable, getHasProblems, getIsEscrow } from '../../selectors/newbuilding';
import { trackLabelClick } from './tracking';

export function LabelsContainer() {
  const isReliable = useSelector(getIsReliable);
  const hasProblems = useSelector(getHasProblems);
  const isEscrow = useSelector(getIsEscrow);

  const onLabelClick = (anchor: string, label: string) => (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor,
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackLabelClick(label);
  };

  return (
    <LabelsLayout>
      {isReliable && (
        <ReliableLabel
          text={<UIText3 color="white_100">Надёжный ЖК</UIText3>}
          tooltipText={'Подробнее о надёжности'}
          icon={<IconTrust16 color="white_100" />}
          onClick={onLabelClick('#reliable', 'tab_reliable_dev')}
        />
      )}
      {hasProblems && (
        <ReliableLabel
          text={<UIText3 color="white_100">Стройка заморожена</UIText3>}
          tooltipText={'Узнать подробности'}
          icon={<IconWarning16 color="white_100" />}
          styleName={'container-problem'}
          onClick={onLabelClick('#problem', 'tab_problem_building')}
        />
      )}
      {isEscrow && (
        <ReliableLabel
          text={<UIText3 color="primary_100">Эскроу</UIText3>}
          tooltipText={'Подробнее об эскроу–счёте'}
          styleName={'container-escrow'}
          onClick={onLabelClick('#escrow', 'tab_escrow')}
        />
      )}
    </LabelsLayout>
  );
}
